export default __webpack_public_path__ + "static/media/postcard_scientists.10b2bcbc.jpg";